import { GlobalContext } from "App";
import { useContext } from "react";

export const useTheme = () => {
  const { theme } = useContext(GlobalContext);

  return theme
    ? (theme as ChatColors)
    : ({
        primary: "#0ea782",
        main: "white",
        incomingIcon: "",
        input: "white",
        chatHeaderText: "",

        incomingChatText: "#FFFFFF",
        outgoingChatText: "#FFFFFF",

        chatBoxColor: "#000000",
        poweredByDentistFind: "#acacac",
      } as ChatColors);
};
type ChatColors = {
  primary: string;
  main: string;
  incomingIcon: string;
  input: string;
  chatHeaderText: string;
  incomingChatText: string;
  outgoingChatText: string;
  chatBoxColor: string;
  poweredByDentistFind: string;
};
